export const ACTION_TYPES = {
  STORE_USER_PROFILE_DATA: 'STORE_USER_PROFILE_DATA',
  UPDATE_USER_PROFILE_PREFERENCE: 'UPDATE_USER_PROFILE_PREFERENCE',

  UPDATE_USER_PROFILE_REQUEST: 'UPDATE_USER_PROFILE_REQUEST',
  UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
  UPDATE_USER_PROFILE_FAILURE: 'UPDATE_USER_PROFILE_FAILURE',

  PROFILE_UPDATED_BANNER_SHOW: 'PROFILE_UPDATED_BANNER_SHOW',
  PROFILE_UPDATED_BANNER_HIDE: 'PROFILE_UPDATED_BANNER_HIDE',
};

const initialState = {
  userProfileData: {},
  userProfileFields: {},
  modifiedFields: {},
  profileUpdatedBanner: {
    show: false,
  },
};

const userProfileReducer = (state = initialState, action) => {
  const { payload = {} } = action;
  switch (action.type) {
    case ACTION_TYPES.STORE_USER_PROFILE_DATA:
      return {
        ...state,
        userProfileData: action.payload.userProfileData,
        userProfileFields: action.payload.userProfileFields,
      };
    case ACTION_TYPES.UPDATE_USER_PROFILE_PREFERENCE:
      return {
        ...state,
        userProfileData: {
          ...state.userProfileData,
          [payload.fieldName]: payload.data[payload.fieldName],
        },
      };
    case ACTION_TYPES.UPDATE_USER_PROFILE_REQUEST:
      return {
        ...state,
        modifiedFields: {
          ...state.modifiedFields,
          [payload.fieldName]: {
            status: 'loading',
          },
        },
      };
    case ACTION_TYPES.UPDATE_USER_PROFILE_SUCCESS:
      return {
        ...state,
        modifiedFields: {
          ...state.modifiedFields,
          [payload.fieldName]: {
            status: 'saved',
          },
        },
      };
    case ACTION_TYPES.UPDATE_USER_PROFILE_FAILURE:
      return {
        ...state,
        modifiedFields: {
          ...state.modifiedFields,
          [payload.fieldName]: {
            status: '',
          },
        },
      };
    case ACTION_TYPES.PROFILE_UPDATED_BANNER_SHOW:
      return {
        ...state,
        profileUpdatedBanner: {
          show: true,
        },
      };
    case ACTION_TYPES.PROFILE_UPDATED_BANNER_HIDE:
      return {
        ...state,
        profileUpdatedBanner: {
          show: false,
        },
      };
    default:
      return state;
  }
};

export default userProfileReducer;
